import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../core/authentication/authentication.service';

/*
  Usage: 
    canActivate: [RedirectIfLoggedInGuard],
    data: { redirectTo: 'whatever route you want. Default is dashboard' }
*/

@Injectable({
  providedIn: 'root',
})
export class RedirectIfLoggedInGuard  {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const redirectTo = next && next.data && next.data.redirectTo ? next.data.redirectTo : 'dashboard';

    if (this.authService.isLoggedIn()) {
      this.router.navigate([redirectTo]);
      return false;
    } else {
      return true;
    }
  }
}
